import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Typography } from "@mui/material";
export const DetailTblCard = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={0.5} className=" easy-putaway-container-v1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div className="easy-putaway-card-v1">
            <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={12} md={12} className="easy-putaway-card-sub-Item">
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-ItemName"
                >
                  {item.PartyName}
                </Typography>
              </Grid>
              <Grid item xs={3} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Ref.No
                </Typography>
              </Grid>
              <Grid item xs={9} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_RefDocNo}
                </Typography>
              </Grid>
              <Grid item xs={3} md={6}>
                <Typography
                  variant="subtitle2"
                  className="easy-putaway-card-sub-label"
                >
                  VocName
                </Typography>
              </Grid>
              <Grid item xs={9} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.VocName}
                </Typography>
              </Grid>
              <Grid item xs={3} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Cluster
                </Typography>
              </Grid>
              <Grid item xs={9} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.ClusterName}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  Weight
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_Weight}
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="span"
                  className="easy-putaway-card-sub-label"
                >
                  CBM
                </Typography>
              </Grid>
              <Grid item xs={2} md={6}>
                <Typography
                  variant="body1"
                  className="easy-putaway-card-sub-value"
                >
                  {item.B_CBM}
                </Typography>
              </Grid>
               
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
